module.exports = __webpack_public_path__ + "static/media/audio.063cbe3d.mp3";